// client/src/components/Breadcrumb.js
import React from "react";
import { useIsMobile } from "../hooks/useIsMobile";

export default function Breadcrumb({ items, onItemClick }) {
  const isMobile = useIsMobile();

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav
      className="app-breadcrumb"
      style={{
        display: "flex",
        alignItems: "center",
        gap: isMobile ? "6px" : "8px",
        fontSize: isMobile ? "13px" : "14px",
        color: "var(--ink-600, #64748b)",
        marginBottom: isMobile ? "12px" : "14px",
        flexWrap: "wrap",
      }}
      aria-label="Breadcrumb"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isClickable = item.onClick && !isLast;

        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <span
                style={{
                  color: "var(--ink-400, #94a3b8)",
                  userSelect: "none",
                }}
                aria-hidden="true"
              >
                /
              </span>
            )}
            {isClickable ? (
              <button
                type="button"
                onClick={item.onClick}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  color: "var(--ink-600, #64748b)",
                  cursor: "pointer",
                  fontSize: "inherit",
                  textDecoration: "none",
                  transition: "color 0.2s",
                  touchAction: "manipulation",
                  minHeight: isMobile ? "44px" : "auto",
                  display: "inline-flex",
                  alignItems: "center",
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "var(--brand-500, #8b5cf6)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "var(--ink-600, #64748b)";
                }}
                aria-label={item.label}
              >
                {item.label}
              </button>
            ) : (
              <span
                style={{
                  color: isLast
                    ? "var(--ink-900, #0f172a)"
                    : "var(--ink-600, #64748b)",
                  fontWeight: isLast ? 600 : 400,
                }}
                aria-current={isLast ? "page" : undefined}
              >
                {item.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

